import { render, staticRenderFns } from "./TarifDetail.vue?vue&type=template&id=9fffd050&scoped=true&"
import script from "./TarifDetail.vue?vue&type=script&lang=js&"
export * from "./TarifDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fffd050",
  null
  
)

export default component.exports